"use client"

import { useRouter } from "next/navigation"

const NotFound = () => {
  const { replace } = useRouter()
  return replace("/dashboard")
}

export default NotFound
